const mediaItems = [
  {
    title: '独家深扒｜某知名导演私生活混乱内幕全记录',
    views: '128.6万',
    time: '3天前',
    duration: '15:28',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20scene%20with%20dramatic%20red%20spotlight%20on%20dark%20background%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20warm%20amber%20and%20crimson%20tones%2C%20editorial%20quality%2C%20modern%20composition&width=800&height=500&seq=media-thumb-01&orientation=landscape',
    hot: true,
  },
  {
    title: '某女团成员私下接客实锤视频曝光',
    views: '96.3万',
    time: '5天前',
    duration: '22:41',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20scene%20with%20dramatic%20backlighting%20and%20warm%20crimson%20gradients%2C%20silhouette%20figures%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20and%20mysterious%20mood&width=800&height=500&seq=media-thumb-02&orientation=landscape',
    hot: true,
  },
  {
    title: '上市公司CEO涉嫌内幕交易被拍下关键证据',
    views: '87.9万',
    time: '1周前',
    duration: '09:15',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20office%20scene%20with%20dramatic%20amber%20lighting%20and%20dark%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20editorial%20quality%2C%20warm%20contrast%20tones&width=800&height=500&seq=media-thumb-03&orientation=landscape',
    hot: false,
  },
  {
    title: '某知名歌手演唱会假唱实锤高清录像',
    views: '203.1万',
    time: '2周前',
    duration: '31:02',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20concert%20lighting%20scene%20with%20dramatic%20red%20and%20golden%20beams%2C%20dark%20silhouette%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20mysterious%20mood%2C%20warm%20gradients&width=800&height=500&seq=media-thumb-04&orientation=landscape',
    hot: true,
  },
  {
    title: '某直播平台头部主播刷量造假全过程录像',
    views: '54.7万',
    time: '3周前',
    duration: '18:50',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20screen%20scene%20with%20warm%20orange%20and%20crimson%20glow%2C%20dark%20surroundings%2C%20modern%20tech%20vibe%2C%20cinematic%20lighting%2C%20editorial%20quality%2C%20mysterious%20atmosphere&width=800&height=500&seq=media-thumb-05&orientation=landscape',
    hot: false,
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-vidicon-fill"></i>
            精彩视频
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            精选黑料视频在线播放热门内容，高清无广告
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i > 0 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="px-2 py-1 rounded bg-black/50 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {item.duration}
                  </span>
                  <span className="flex items-center gap-1 text-background-50 text-xs">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                {item.hot && (
                  <div className="absolute top-3 left-3">
                    <span className="flex items-center gap-1 px-2 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                      <i className="ri-fire-fill text-xs"></i>
                      热门
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {item.time}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5">
          {mediaItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group flex flex-col sm:flex-row bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative sm:w-[240px] shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 left-2">
                  <span className="px-2 py-0.5 rounded bg-black/50 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}